var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`px-2 font-18 py-1 badge-${this.id}`},[_c('v-layout',{staticClass:"d-flex",attrs:{"align-center":""}},[_c('img',{attrs:{"width":"32px","height":"32px","src":require(`@/assets/mock/media_panel_${this.id}.png`)}}),_c('v-flex',{staticClass:"font-18"},[_vm._v(_vm._s(_vm.category))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }